'use client';

import { useState } from 'react';
import { LogOut } from 'lucide-react';
import { api, invalidateProfile } from '@/lib/api';
import { useRouter } from '@/i18n/routing';
import { CHAT_STORE_KEY } from './Chat';

export default function LogoutButton() {
  const router = useRouter();
  const [busy, setBusy] = useState(false);

  async function logout() {
    if (busy) return;
    setBusy(true);
    try {
      await api.logout();
    } catch {
      /* ignore — clear session locally regardless */
    }
    invalidateProfile(); // the next account must not inherit this role/plan
    try {
      localStorage.removeItem(CHAT_STORE_KEY); // the next account must not see this chat
    } catch {
      /* ignore */
    }
    router.replace('/login');
  }

  return (
    <button
      onClick={logout}
      disabled={busy}
      className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-zinc-100 py-2.5 text-sm font-medium text-rose-600 active:scale-[0.99] disabled:opacity-50 dark:bg-zinc-800 dark:text-rose-400"
    >
      <LogOut size={16} /> 登出
    </button>
  );
}
